export default "__VITE_ASSET__DGMdMTy1__"